import "./backToTop.scss";
import MenuArrowBlack from "../../assets/common/menu-arrow-black.svg";

function BackToTop(props) {
	function scrollToTop() {
		props.window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	}

	return (
		<div
			id="back-to-top"
			className="flex-row"
			onClick={() => scrollToTop()}
			style={{
				...props.styles,
			}}
		>
			<img alt="Verified Arrow Icon" src={MenuArrowBlack} />
			<span className="back-to-top-text">{props.backToTopText}</span>
		</div>
	);
}

export default BackToTop;
